





























































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import Editor from '@/components/Editor'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'CampaignCheckoutVendorListingEdit'

  resources:
    listing_line_items:
      resourceName: 'line_item'
      slug: 'campaigns/:campaignId/scanner/vendor_listings/:vendorListingId/shopping_cart_line_items'

  vue:
    components: {
      Modal,
      Editor,
      RequestButton,
      LoadingIndicator,
    }

    data: ->
      modal:
        show: true
      dateRange: null
      quantity: null
      priceInDollars: null
      payoutInDollars: null
      brandProvides: null
      organizerInstructions: null

    computed:
      lineItem: -> @listing_line_items?[0]
      vendorListingId: -> @$route.params.vendorListingId
      vendorListing: -> @ctxVendorListing @lineItem

    methods:
      onLoadCollectionCompleted: (resourceKey) ->
        @initializeFields() if resourceKey is 'listing_line_items'

      initializeFields: ->
        return unless @lineItem
        { available_dates } = @lineItem
        startDate = available_dates[0].starts_on
        endDate = available_dates[available_dates.length - 1].starts_on
        @dateRange = [startDate, endDate]
        @quantity = @lineItem.quantity
        @priceInDollars = @lineItem.price_in_dollars
        @payoutInDollars = @lineItem.payout_in_dollars
        @brandProvides = @lineItem.vars.brand_provides
        @organizerInstructions = @lineItem.vars.organizer_instructions

      adaptPayload: ->
        vendor_listing_id: @vendorListing.id
        atts:
          start_date: @dateRange[0]
          end_date: @dateRange[1]
          quantity: @quantity
          price_in_cents: @priceInDollars * 100
          payout_in_cents: @payoutInDollars * 100
          brand_provides: @brandProvides
          organizer_instructions: @organizerInstructions

      hiSave: ->
        @triggerResource 'listing_line_items', 'update_vendor_listing_line_item', @adaptPayload()
      onListingLineItemsUpdateVendorListingLineItem: ->
        @close()

      close: ->
        @modal.show = false
        @$router.push name: 'CampaignCheckoutStage'

export default VueOptions.vue settings
